module.exports = __webpack_public_path__ + "img/2_237.33018f2c.png";